import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { HarlequinBusinessCardStackBackgroundViewModel } from './harlequin-business-card-stack-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';
import { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-harlequin-business-card-stack-background',
  templateUrl: './harlequin-business-card-stack-background.component.html',
  styleUrls: ['./harlequin-business-card-stack-background.component.scss'],
  providers: [HarlequinBusinessCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HarlequinBusinessCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: HarlequinBusinessCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
